import {ChangeDetectionStrategy, Component, input} from "@angular/core";

export type BadgeVariant = "success" | "danger" | "warning" | "info" | "neutral";
export type BadgeSize = "small" | "medium";

@Component({
    selector: "badge",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "[attr.data-variant]": "variant()",
        "[attr.data-size]": "size()",
    },
    template: `<ng-content/>`,
    styles: `
        :host {
            display: inline-flex;
            align-items: center;
            padding: 4px 10px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 500;
            line-height: 1;
            white-space: nowrap;
        }

        :host([data-size="small"]) {
            padding: 2px 8px;
            font-size: 11px;
        }

        :host([data-variant="success"]) {
            background: rgba(46, 125, 50, 0.12);
            color: #2e7d32;
        }

        :host([data-variant="danger"]) {
            background: rgba(198, 40, 40, 0.12);
            color: #c62828;
        }

        :host([data-variant="warning"]) {
            background: rgba(237, 108, 2, 0.14);
            color: #b25400;
        }

        :host([data-variant="info"]) {
            background: rgba(33, 150, 243, 0.12);
            color: #1565c0;
        }

        :host([data-variant="neutral"]) {
            background: rgba(0, 0, 0, 0.06);
            color: rgba(0, 0, 0, 0.65);
        }
    `,
})
export class BadgeComponent {
    variant = input<BadgeVariant>("neutral");
    size = input<BadgeSize>("medium");
}
